import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  createStyles,
  Divider,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Modal,
  Backdrop,
  Fade,
  Theme,
} from '@material-ui/core';
import { QUEST_TYPES, QuestType } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
      outline: 'none',
    },
    root: {
      minWidth: 400,
    },
    listItem: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
);

type Props = {
  open: boolean;
  onSelect: (type: QuestType) => void;
  onClose: () => void;
};

export const QuestTypeSelectModal = ({ open, onSelect, onClose }: Props) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.form}>
          <Card className={classes.root}>
            <CardHeader title="Выберите тип задания" />
            <Divider />
            <CardContent>
              <List disablePadding>
                {QUEST_TYPES.map((type) => (
                  <ListItem
                    key={type.value}
                    className={classes.listItem}
                    onClick={() => onSelect(type.value)}
                  >
                    <ListItemText primary={type.label} />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </div>
      </Fade>
    </Modal>
  );
};
